<script setup lang="ts">
    import { ShippingWizard } from './wizard';
    import { ExtractionSpecification } from './extractionSpecification';
    import { computed, ComputedRef, PropType } from 'vue';
    import { LibraryExtractionSpecification } from './librarySpecification';

    const emit = defineEmits<{
        removeLibraryClick: [name: string];
    }>();

    const props = defineProps({
        wizard: {
            type: Object as PropType<ShippingWizard<ExtractionSpecification> | null>,
            required: false,
            default: null
        }
    });

    const definitionExtractions: ComputedRef<LibraryExtractionSpecification[]> = computed(() => {
        if (props.wizard?.type === 'LibraryDefinitions') {
            return props.wizard!.elements as LibraryExtractionSpecification[];
        }
        return [];
    });
</script>

<template>
    <template v-if="wizard?.type === 'LibraryDefinitions'">
        <div
            class="shipping-library-options-container">
            <div
                v-for="extraction in definitionExtractions"
                :key="extraction.libraryName"
                class="shipping-library-options-box">
                <div class="pb-3">
                    <b>{{ extraction.libraryName }}</b>
                </div>
                <b-field
                    grouped
                    position="is-left">
                    <b-checkbox v-model="extraction.includeLibraryGroups">
                        Library groups
                    </b-checkbox>
                    <b-checkbox v-model="extraction.includeAccessGroups">
                        Access groups
                    </b-checkbox>
                    <!-- NOT YET IMPLEMENTED (not part of version 1)
                    <b-checkbox v-model="extraction.includeSubscriptions">
                        Subscriptions
                    </b-checkbox>
                    <b-checkbox v-model="extraction.includeAliases">
                        Aliases
                    </b-checkbox>
                    <b-checkbox v-model="extraction.includeAccessPolicies">
                        Access policies
                    </b-checkbox>
                    NOT YET IMPLEMENTED -->
                    <b-checkbox v-model="extraction.includeCodeSets">
                        Library sets
                    </b-checkbox>
                    <p class="control">
                        <b-button
                            icon-left="delete"
                            @click="emit('removeLibraryClick', extraction.libraryName)">
                            Unselect
                        </b-button>
                    </p>
                </b-field>
            </div>
        </div>
    </template>
</template>
